import { useState, useEffect } from 'react';
import Toast from './toast';
let deferredPrompt = null;

/**
 * Gets device info on screensize & touchscreen capabilities
 * @returns 
 */
export function useDeviceInfo() {
    const [device, setDevice] = useState(getDeviceType());
    const [isTouch, setIsTouch] = useState(isTouchDevice());

    function isIpad() {

        const userAgent = navigator.userAgent.toLowerCase() || "";
        const platform = navigator.userAgentData?.platform || "";

        return (
            /ipad/.test(userAgent) ||
            (/macintosh/.test(userAgent) && navigator.maxTouchPoints > 1) ||
            platform === "iPad"
        );
    };

    function getDeviceType() {
        if(isIpad()) return "tablet";
        const width = window.innerWidth;
        if (width <= 768) return "mobile";
        if (width <= 1024) return "tablet";
        return "desktop";
    }


    function isTouchDevice() {
        let val = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
        // console.log("Device Touch Capabilities: ", val);
        return val;
    }

    useEffect(() => {
        const handleResize = () => {
            setDevice(getDeviceType());
            setIsTouch(isTouchDevice());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return { device, isTouch };
}

/**
 * Checks if osprey is already installed
 * @returns {boolean} true or false
 */
export function getIfPWAInstalled() {
    // iOS Safari
    const isIOSStandalone = window.navigator.standalone === true;
    if(isIOSStandalone) console.log("IOS standalone true");

    // Android / other browsers
    const isDisplayModeStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if(isDisplayModeStandalone) console.log("andriod/non-ios standalone true");

    // Chrome / Edge related apps API (works only on supported browsers)
    // const checkRelatedApps = async () => {
    //     if (!navigator.getInstalledRelatedApps) return false;
    //     try {
    //         console.log("is final has been downloaded")
    //         const relatedApps = await navigator.getInstalledRelatedApps();
    //         return relatedApps.some(app =>
    //             app.platform === 'webapp' &&
    //             app.url === 'https://manta-scouting-osprey.vercel.app/manifest.json'
    //         );
    //     } catch {
    //         return false;
    //     }
    // };

    return isIOSStandalone || isDisplayModeStandalone;
}

/**
 * Gets if the device is IOS or not
 * @returns 
 */
function getIfIos(){
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing
    e.preventDefault();
    // Store the event for later use
    deferredPrompt = e;
});

/**
 * Attempts to download osprey onto the device
 * @returns 
 */
export async function downloadToHomescreen(){
    if(getIfPWAInstalled() === true){
        Toast.info("Osprey already installed on this device");
        return true;
    }
    if(deferredPrompt == null || !deferredPrompt){
        if (getIfIos()) {
            Toast.info("Automatic Installation not availible on IOS. Tap the Share button in your browser and select 'Add to Home Screen' to install Osprey.");
            return false;
        }

        // Unsupported browser
        Toast.info("Automatic Installation not availible. Instead tap the Share button in your browser and select 'Add to Home Screen' to install Osprey.");
        return false;
    }
    try {
        const choice = await deferredPrompt.prompt();
        return choice;
    } catch (err) {
        console.error("Error showing install prompt:", err);
        return false;
    }
}